import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, Clock, Users, Calendar, MessageSquare, Gift, Lightbulb } from 'lucide-react';
import MemberAdvantageCard from '../components/MemberAdvantageCard';
import { EditableContent } from '../components/EditableContent';

const Home = () => {
  const advantages = [
    {
      icon: Clock,
      title: 'LEARNING LUNCH',
      description: 'Participez à des sessions captivantes animées par des experts et interlocuteurs inspirants, abordant des thématiques actuelles et stratégiques. Ces événements combinent apprentissage et interactivité, offrant des perspectives innovantes pour approfondir vos connaissances et enrichir vos compétences dans le secteur.',
    },
    {
      icon: Users,
      title: 'RESEAUTAGE',
      description: 'Créez des connexions durables et enrichissantes grâce à nos rencontres dédiées au partage d\'expériences et à la collaboration. Nous favorisons les échanges entre professionnels de l\'assurance, qu\'ils soient expérimentés ou en début de carrière, pour élargir vos opportunités et renforcer votre réseau.',
    },
    {
      icon: Calendar,
      title: 'EVENEMENTS',
      description: 'Découvrez des conférences de qualité animées par des interlocuteurs experts et inspirants, ainsi que des ateliers interactifs. Ces événements sont conçus pour enrichir vos connaissances et vous offrir des perspectives d\'avenir sur le secteur.',
    },
    {
      icon: MessageSquare,
      title: 'CHAT BOT POUR ASDASIENS',
      description: 'En tant que membre, accédez à notre Chat Bot ASDA, votre assistant digital disponible 24/7. Posez vos questions, trouvez des ressources utiles et restez informé en un clic. Un outil pour enrichir votre expérience et maximiser les avantages de votre adhésion.',
    },
    {
      icon: Gift,
      title: 'OFFRES EXCLUSIVES',
      description: 'En tant qu\'adhérent, bénéficiez de réductions exclusives et de tarifs préférentiels dans nos établissements partenaires. Un avantage concret pour valoriser votre adhésion.',
    },
    {
      icon: Lightbulb,
      title: 'PARRAINAGE/MENTOR',
      description: 'Bénéficiez d\'un accompagnement personnalisé par des experts pour développer vos compétences et atteindre vos objectifs professionnels.',
    },
  ];

  return (
    <div className="bg-beige">
      {/* Hero Section */}
      <div className="relative bg-dark">
        <div className="max-w-7xl mx-auto px-4 py-24 sm:px-6 lg:px-8">
          <div className="text-center">
            <h1 className="text-4xl font-serif font-bold tracking-tight text-beige sm:text-5xl md:text-6xl">
              <EditableContent
                section="home"
                contentKey="hero-title"
                defaultValue="ASDA Genève"
              />
            </h1>
            <p className="mt-3 max-w-md mx-auto text-base text-cream/90 sm:text-lg md:mt-5 md:text-xl md:max-w-3xl">
              <EditableContent
                section="home"
                contentKey="hero-subtitle"
                defaultValue="Association Suisse des Diplômés en Assurance – Section Genève"
              />
            </p>
            <div className="mt-8 flex justify-center gap-4">
              <Link
                to="/join"
                className="inline-flex items-center px-6 py-3 border border-transparent text-base font-medium rounded-md text-dark bg-beige hover:bg-cream transition-colors duration-300"
              >
                <EditableContent
                  section="home"
                  contentKey="hero-cta"
                  defaultValue="Devenir membre"
                />
                <ArrowRight className="ml-2 h-5 w-5" />
              </Link>
              <Link
                to="/about"
                className="inline-flex items-center px-6 py-3 border border-beige text-base font-medium rounded-md text-beige hover:bg-dark/80 transition-colors duration-300"
              >
                <EditableContent
                  section="home"
                  contentKey="hero-secondary-cta"
                  defaultValue="En savoir plus"
                />
              </Link>
            </div>
          </div>
        </div>
      </div>

      {/* Avantages Section */}
      <section className="py-24 bg-cream/30">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-3xl font-serif font-bold text-dark mb-4">
              <EditableContent
                section="home"
                contentKey="advantages-title"
                defaultValue="Pourquoi nous rejoindre ?"
              />
            </h2>
            <p className="text-lg text-dark/80">
              <EditableContent
                section="home"
                contentKey="advantages-subtitle"
                defaultValue="Découvrez les avantages d'être membre de l'ASDA Genève"
              />
            </p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {advantages.map((advantage, index) => (
              <MemberAdvantageCard 
                key={index} 
                {...advantage} 
                index={index}
              />
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default Home;